import { render, staticRenderFns } from "./TerritoryIncludedPostalCodes.vue?vue&type=template&id=2cce1dc4&"
import script from "./TerritoryIncludedPostalCodes.vue?vue&type=script&lang=ts&"
export * from "./TerritoryIncludedPostalCodes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports